import * as R from "ramda";
import Moment from "moment";
import Big from "big.js";
import BaseEntity from "./base.entity";
import Customer from "./customer.entity";
import { DocumentTypes, PaymentTypes, SaleStatus } from "core/enum";

const cartItemDiscount = cartItem => cartItem.discount;
const cartItemSubtotal = cartItem =>
  cartItem.quantity * cartItem.sellable.sell_value;
const cartItemRevenue = cartItem =>
  cartItemSubtotal(cartItem) - cartItemDiscount(cartItem);
const cartItemCost = cartItem =>
  cartItem.quantity * (cartItem.sellable.cost_value || 0);
const saleRevenue = R.pipe(
  R.map(cartItemRevenue, R.__),
  R.sum
);
const saleCost = R.pipe(
  R.map(cartItemCost, R.__),
  R.sum
);
const saleSubtotal = R.pipe(
  R.map(cartItemSubtotal, R.__),
  R.sum
);
const saleDiscounts = R.pipe(
  R.map(cartItemDiscount, R.__),
  R.sum
);

export default class Sale extends BaseEntity {
  revenues() {
    return saleRevenue(this.cart_items) + this.tip;
  }

  costs() {
    return saleCost(this.cart_items);
  }

  discounts() {
    return saleDiscounts(this.cart_items);
  }

  discountPercentual() {
    return Big(this.discounts())
      .div(saleSubtotal(this.cart_items))
      .toFixed(2);
  }

  hasDiscount() {
    return !!this.cart_items.find(cartItem => cartItem.discount > 0);
  }

  itemCount() {
    return this.cart_items.length;
  }

  absoluteProfit() {
    return this.revenues() - this.costs();
  }

  relativeProfit() {
    const revenues = this.revenues();

    if (revenues === 0) {
      return "0.00";
    }

    return Big(this.absoluteProfit())
      .div(revenues)
      .times(100)
      .toFixed(2);
  }

  receiptName() {
    const documentType = DocumentTypes[this.document.type];
    const documentNumber = this.document.number;
    return `${documentType} n.: ${documentNumber}`;
  }

  getDocumentData() {
    const documentType = DocumentTypes[this.document.type];
    const documentNumber = this.document.number;
    return {
      type: documentType,
      number: documentNumber,
      serie: this.document.serie
    };
  }

  paymentMethods() {
    const paymentTypes = R.uniq(
      this.payments.map(salePayment => {
        const type = salePayment.type;
        if (
          type === "credit_card" &&
          parseInt(salePayment.metadata.installments, 10) > 1
        ) {
          return PaymentTypes.installments;
        } else {
          return PaymentTypes[salePayment.type] || type;
        }
      })
    );
    return paymentTypes
      ? R.sortBy(R.identity, paymentTypes).join(", ")
      : "Outros";
  }

  statusLabel() {
    return SaleStatus[this.status];
  }

  getUpdatedAt() {
    return new Moment(this.updated_at);
  }

  getCreatedAt() {
    return new Moment(this.created_at);
  }

  getActivatedAt() {
    return new Moment(this.activated_at);
  }

  getCustomer(customer) {
    if (typeof this.customer !== Customer) {
      this.customer = new Customer(this.customer);
    }

    return this.customer;
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/sale.entity.js